<template>
  <div>
    <div v-if="loaded" >
      <h3 class="overlay-size">
        <span class="prefix_bit"> {{this.prefix}} </span>
        <span class="daily_bit"> {{this.bits}} </span>
        <span class="prefix_bit"> / </span>
        <span class="daily_bitgoal"> {{this.goal}} </span>
      </h3>
    </div>
    <div v-else>
      Loading....
    </div>

  </div>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'DailySubGoalView',

  data: () => ({
    goal: 0,
    bits: 0,
    loaded: false,
    prefix: '',
  }),
  components: {
  },
  mounted() {
    this.intervalId = window.setInterval(this.updateTimer, 2500);
    this.updateTimer();
  },
  computed: {
  },
  destroyed() {
    clearInterval(this.intervalId);
  },
  methods: {
    updateTimer() {
      BackendService.loadBitGoals(this.$router.currentRoute.params.token).then((data) => {
        // console.log(data.data);
        this.loaded = true;
        this.goal = data.data.goal;
        this.bits = data.data.bits;
        this.prefix = data.data.prefix;
      });
    },
  },
};

</script>

<style lang="scss">
.transparent.theme--dark.v-application {
  background-color: transparent;
  color: inherit;
}

html {
  overflow: auto;
}

.overlay-size {
  font-size: 60px;
}
</style>
